/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedCreatorSpotlightProductTile_edge$ref = any;
export type SbRespCreatorSpotlightModule_collectionsModules$ref = any;
export type SbRespCreatorSpotlightModule_collectionsModules = {
    readonly title: string | null;
    readonly photo: string | null;
    readonly description: string | null;
    readonly link: string | null;
    readonly linkText: string | null;
    readonly itemsConnection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
            } | null;
            readonly " $fragmentRefs": SbSharedCreatorSpotlightProductTile_edge$ref;
        } | null> | null;
    } | null;
    readonly " $refType": SbRespCreatorSpotlightModule_collectionsModules$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespCreatorSpotlightModule_collectionsModules",
  "type": "CollectionsModulesCreatorSpotlight",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "photo",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "description",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "link",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "linkText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "itemsConnection",
      "storageKey": null,
      "args": null,
      "concreteType": "CmsItemsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CmsItemsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "FragmentSpread",
              "name": "SbSharedCreatorSpotlightProductTile_edge",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'c34945bef02973a5286bfa24baa69612';
export default node;
